
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 13.125a3.126 3.126 0 010-6.25 3.126 3.126 0 010 6.25zm0-5A1.878 1.878 0 008.125 10c0 1.033.842 1.875 1.875 1.875A1.878 1.878 0 0011.875 10 1.878 1.878 0 0010 8.125z","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.675 18.492a2.27 2.27 0 01-.525-.067 2.047 2.047 0 01-1.225-.925l-.1-.167c-.492-.85-1.167-.85-1.658 0l-.092.159c-.275.466-.708.8-1.225.933a1.951 1.951 0 01-1.525-.208l-1.433-.825a2.208 2.208 0 01-.817-3.017c.242-.425.308-.808.167-1.05-.142-.242-.5-.383-.992-.383a2.212 2.212 0 01-2.208-2.209V9.267c0-1.217.991-2.209 2.208-2.209.492 0 .85-.141.992-.383.141-.242.083-.625-.167-1.05a2.218 2.218 0 01-.217-1.675 2.15 2.15 0 011.034-1.342l1.441-.825c.942-.558 2.184-.233 2.75.725l.1.167c.492.85 1.167.85 1.659 0l.091-.158c.567-.967 1.809-1.292 2.759-.725l1.433.825a2.208 2.208 0 01.817 3.016c-.242.425-.309.809-.167 1.05.142.242.5.384.992.384 1.216 0 2.208.991 2.208 2.208v1.467a2.212 2.212 0 01-2.208 2.208c-.492 0-.85.142-.992.383-.142.242-.083.625.167 1.05a2.18 2.18 0 01.216 1.675 2.15 2.15 0 01-1.033 1.342l-1.442.825a2.074 2.074 0 01-1.008.267z","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    